export enum EVENT_TYPES {
  // TODO добиться, чтобы backend поменяли названия
  CHECK_CONNECTION = "check_connection",
  MESSAGE_INCOME = "message_incoming",
  MESSAGE_FILE_OUTGOING = "message_file_outgoing",
  MESSAGE_OUTGOING = "message_outgoing",
  UPDATE_FILE_MESSAGE = "message_update",

  // new events
  UPDATE_MESSAGE_STATUSES_READ = "opponents.last_read_message",
  TYPING_NOTIFICATION = "opponents.typing_message",
  USER_ENTER = "opponents.user.enter",
}

export const RECONNECT_TIMEOUTS: Record<number, number> = {
  0: 1000,
  1000: 5000,
  5000: 10000,
  10000: 30000,
};
